import StorageUtils from '../utils/StorageUtils';
import { atrasoRenovacao, sessaoExpirada } from '../utils/sessao';
import { firebaseAuth } from './FirebaseConfig';
import { encerrarSessao } from './Api';

const NOVA_TENTATIVA_MS = 60 * 1000;

// DEVN3-760: renova o idToken do Firebase em segundo plano, 10 min antes de vencer, para a
// API nunca receber token vencido (401 → login). Também renova ao voltar para a aba, já que
// o navegador atrasa timers de abas em segundo plano e de computador suspenso. Devolve a
// função que para a renovação (logout/desmontagem).
export function iniciarRenovacaoToken(): () => void {
    let timer: ReturnType<typeof setTimeout> | undefined;
    let parado = false;

    const agendar = (atraso: number) => {
        clearTimeout(timer);
        if (!parado) timer = setTimeout(renovar, atraso);
    };

    async function renovar() {
        if (parado || !(await StorageUtils.getToken())) return;

        if (sessaoExpirada(StorageUtils.getSessaoInicio())) {
            await encerrarSessao();
            return;
        }

        try {
            await firebaseAuth.authStateReady();
            const usuarioFirebase = firebaseAuth.currentUser;
            if (!usuarioFirebase) return;

            const token = await usuarioFirebase.getIdToken(true);
            if (parado) return;

            StorageUtils.setToken(token);
            agendar(atrasoRenovacao(await StorageUtils.getToken()));
        } catch {
            agendar(NOVA_TENTATIVA_MS);
        }
    }

    const aoVoltarParaAba = async () => {
        if (document.visibilityState !== 'visible') return;
        if (atrasoRenovacao(await StorageUtils.getToken()) === 0) renovar();
    };

    StorageUtils.getToken().then(token => agendar(atrasoRenovacao(token)));
    document.addEventListener('visibilitychange', aoVoltarParaAba);

    return () => {
        parado = true;
        clearTimeout(timer);
        document.removeEventListener('visibilitychange', aoVoltarParaAba);
    };
}
